<template>
  <div class="browse-work">
    <div v-if="work" class="browse">
      <slot name="header" />
      <EditionInfo v-if="work && work.urn" :work="work" />
      <BrowseSearch
        :work=work
        @selected="selection => $emit('selected', selection)"
      />
      <div v-if="!filterBrowseContents" class="browse-contents">
        <div class="small-link">
          <div @click="collapse">{{ $t('collapseAllButtonLabel') }}</div>
        </div>
        <div dir="rtl" v-if="superheadings.length">
          <BrowseSuperheading
            v-for="(superheading) in superheadings"
            :key="superheading.uid"
            :superheading="superheading"
            :work=work
            @selected="selection => $emit('selected', selection)"
          />
        </div>
        <div v-else>
          <small>{{ $t('loading') }}</small>
        </div>
      </div>
    </div>
    <div v-else>
      <small>{{ $t('loading') }}</small>
    </div>
  </div>
</template>

<script>
  import BrowseSuperheading from './BrowseSuperheading.vue';
  import BrowseSearch from './BrowseSearch.vue';
  import EditionInfo from '../EditionInfo.vue';
  import { COLLAPSE_ALL_BROWSE_CONTENT } from '../../constants';

  export default {
    components: {
      BrowseSuperheading,
      BrowseSearch,
      EditionInfo,
    },
    props: ['work'],
    computed: {
      superheadings() {
        const workContentData = this.$store.state.browseContentData[this.work.urn];
        return workContentData ? workContentData.map((edge) => {
          const { node } = edge;
          node.firstSectionIdx = node.sections.edges[0].node.idx;
          return node;
        }) : [];
      },
      filterBrowseContents() {
        return this.$store.state.filterBrowseContents;
      },
    },
    methods: {
      collapse() {
        this.$store.dispatch(COLLAPSE_ALL_BROWSE_CONTENT, { status: true });
      },
    },
  };
</script>

<style lang="scss">
  @import './Browse';

  .browse-work {

    padding-bottom: 2rem;

    .small-link {
      font-size: 14px;
      color: #adb5bd;
      padding: 20px 0px 20px 10px;
      div {
        display: inline-block;
        padding-right: 1.0em;
      }
    }

    .small-link > div:hover {
      cursor: pointer;
      background: #fff;
      color: #495057;
    }
  }
</style>
